import React, { useMemo } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../../../store/hooks'
import { Button } from '../../../../../../../components/Button/Button'
import './MeetingSummaryAgentCRMButton.scss'
import { openModal } from '../../../../../../../store/modal/modal'
import { selectRoomSession } from '../../../../../../../store/meetingSummary/roomSession'
import { selectMeetingSummarySyncStatus } from '../../../../../../../store/meetingSummaryAgent/meetingSummaryAgent'
import { formatDate } from '../../../../common/aifeatures/utils'
import { Tooltip } from '../../../../../../../components/Tooltip/Tooltip'
import { IntegrationIcon } from '../../../../../../../components/IntegrationIcon'
import { IntegrationServiceId } from '../../../../../../../common/integrations'

export const MeetingSummaryAgentCRMButton: React.FC<{
  serviceId: IntegrationServiceId
  label: string
}> = ({ serviceId, label }) => {
  const dispatch = useAppDispatch()
  const roomSession = useAppSelector(selectRoomSession)
  const meetingSummarySyncStatus = useAppSelector(selectMeetingSummarySyncStatus)

  const serviceSyncStatus = useMemo(() => {
    return meetingSummarySyncStatus.filter((status) => status.serviceId === serviceId)
  }, [serviceId, meetingSummarySyncStatus])

  const getTooltipTitle = () => {
    const serviceIdLabel = serviceId[0].toUpperCase() + serviceId.slice(1)
    if (serviceSyncStatus.length > 0) {
      return `Saved 'Meeting Summary' to ${serviceIdLabel} on ${formatDate(serviceSyncStatus[serviceSyncStatus.length - 1].syncedAt)}`
    }
  }

  if (!roomSession) {
    return null
  }

  const handleSaveClick = () => {
    dispatch(openModal({ type: 'exportMeetingSummary', serviceId, roomSession }))
  }

  return (
    <>
      <Tooltip className='paragraph-small' title={getTooltipTitle()} placement='top' offset={[0, 10]} hidden={serviceSyncStatus.length === 0}>
        <Button className='px-2 py-1 button-medium' variant='header' onClick={handleSaveClick}>
          <div className='d-flex gap-1 align-items-center'>
            <div className='d-flex position-relative'>
              <IntegrationIcon serviceId={serviceId as IntegrationServiceId} className='crm-icon' fill='var(--zocks-gray-900)' />
              <div>{serviceSyncStatus.length > 0 ? <i className='crm-synced-badge bi bi-circle-fill' /> : null}</div>
            </div>
            Save to {label}
          </div>
        </Button>
      </Tooltip>
    </>
  )
}
